




























import { computed, defineComponent, PropType } from '@vue/composition-api';
import { SettingsItem }                        from '@/views/settings/types/types';
import { GlobalContexts, useGlobals }          from '@/hooks/use-globals';
import { Computed }                            from '@/types';

export default defineComponent({
  name: 'cSettingsListItem',
  props: {
    item: {
      type: Object as PropType<SettingsItem>,
      required: true,
    },
  },
  setup() {
    const { i18n }: GlobalContexts = useGlobals();
    const getTranslation: Computed<(prop: string) => string> = computed(() => (prop: string) => (
      i18n.t(`vSettings.settingsListItem.${prop}`)
        .toString()));

    return {
      getTranslation,
    };
  },
});
